import React from 'react'

function ReputationInfo() {
  return (
    <div>ReputationInfo</div>
  )
}

export default ReputationInfo